import { render, staticRenderFns } from "./high_school.vue?vue&type=template&id=cde49c0c&scoped=true"
import script from "./high_school.vue?vue&type=script&lang=js"
export * from "./high_school.vue?vue&type=script&lang=js"
import style0 from "./high_school.vue?vue&type=style&index=0&id=cde49c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde49c0c",
  null
  
)

export default component.exports